import React from 'react';
import { Button, Tabs, Upload, message } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, GetMetaProperties, SetMetaProperties, Model, POST, QueryDetail, QueryOrder, errorCatch, getObjectDisplay, updateInPropertiesUUID, updateInArray, useAuth, useMetaContext, deleteInProperties, contextFilterToObject, foreachInProperties, useClipboardContext, clean, Action, GET, QueryParam, POSTFormData } from 'fennec-ui'
import PageLayout from '../../components/PageLayout';
import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import { goTo } from '../../../common/Tool';
import User from '../../../common/User';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import { UploadOutlined } from '@ant-design/icons';
import YImage from '../../../common/YImage';
import AbstractCollection from '../../../common/AbstractCollection';
import RezultatiPoMeropriyatiu from '../../forms/RezultatiPoMeropriyatiu';

var _ = require('lodash');
const { TabPane } = Tabs;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function FederationadministratorSettingsAbsoluteRating(props) {
    const auth = useAuth()
    const meta = useMetaContext()

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }

        let p = GetMetaProperties(obj)

        //         dateCalc
        // isCalc

        if (name == "TipiReitingov") {
            p = foreachInProperties(p, n => (n.type == "object" && n.name == "ReitingStatusSorevnovaniyaTipReitinga"), (n) => {
                return {
                    ...n,
                    relation: {
                        ...n.relation,
                        uiFilter: () => [
                            {
                                name: "meropriyatie.nazvanieMeropriyatiya",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "meropriyatie.mestoProvedeniya",
                                sort: true,
                                filter: true,
                            },
                            {
                                name: "meropriyatie.nachaloSorevnovaniya",
                                type: "date",
                                queryRaw: (filterByKey, item, akey) => {
                                    return QueryParam("w-lge-" + akey, filterByKey.format("YYYY-MM-DD"))
                                },
                                sort: true,
                                filter: true,
                                sorted: "ASC",
                            },
                            {
                                name: "tantsevalnayaDistsiplina",
                                filter: true,
                                queryFilter: [
                                    QueryOrder("nazvanie", "ASC")
                                ]
                            },
                            {
                                label: "Танцевальная дисциплина",
                                name: "tantsevalnayaDistsiplina.nazvanie",
                                sort: true,
                            }
                        ],
                    },
                    // displayString: (item) => {
                    //     return dayjs(item?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " +
                    //         item?.meropriyatie?.nazvanieMeropriyatiya + ", " +
                    //         _.get(item, "meropriyatie.mestoProvedeniya.name")
                    // },
                    display: (item) => {
                        return (
                            <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "0px", marginBottom: "0px" }}>
                                <div>
                                    <div style={{ width: "79px", height: "79px", overflow: "hidden", borderRadius: "4px" }}>
                                        <YImage item={item?.meropriyatie} width={79} hidePreview={true} />
                                    </div>
                                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "2px", fontSize: "12px" }}>
                                        <span style={{
                                            marginRight: "5px",
                                            borderRadius: "5px",
                                            backgroundColor: (dayjs().isAfter(item?.meropriyatie?.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                            color: (dayjs().isAfter(item?.meropriyatie?.okonchanieSorevnovaniya)) ? "black" : "white",
                                            fontWeight: (dayjs().isAfter(item?.meropriyatie?.okonchanieSorevnovaniya)) ? "400" : "600",
                                            fontSize: "14px",
                                            boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                            padding: "2px 4px"
                                        }}>{dayjs(item?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                    </div>
                                </div>
                                <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                        <span style={{ fontWeight: "600" }}>
                                            <a href={`/fed/event/${item?.meropriyatie?.ID}`}>{item?.meropriyatie?.nazvanieMeropriyatiya}</a>
                                        </span>
                                    </div>
                                    <div>
                                        г. <span>{item?.meropriyatie?.mestoProvedeniya?.name}</span>
                                    </div>
                                    <div>
                                        {item?.tantsevalnayaDistsiplina?.nazvanie} ({item?.tantsevalnayaDistsiplina?.shortName})
                                    </div>
                                    <div>
                                        {item?.kategoriyaTurnira?.nazvanie} ({item?.kategoriyaTurnira?.maksBallVZachet})
                                    </div>
                                    <div style={{ fontSize: "12px" }}>
                                        {(!!item?.isCalc) && <span><i className="fa fa-circle" style={{ color: "#27b327" }}></i> Рассчитан {(item?.dateCalc) && <span>({dayjs(item?.dateCalc).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')})</span>}</span>}
                                        {(!item?.isCalc) && <span><i className="fa fa-circle" style={{ color: "red" }}></i>  Не рассчитан {(item?.dateCalc) && <span></span>}</span>}
                                    </div>
                                </div>
                            </div>
                        )
                    },
                }
            })
        }

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "DateCalc", "IsCalc"])

        // if(obj.name === "ParametriProtokolovTesta"){
        //     p = deleteInProperties(p, ["DopustimoeKolvoOshibok"])
        // }

        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.type == "object"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("ID", "ASC"),
            ],
            dropdownActions: (value, item, meta, contextObject) => {
                let name = item?.relation?.reference?.object;
                let m = meta[name]

                return [{
                    title: "Создать",
                    form: Model,

                    object: {},

                    // links: true,
                    // links: "inline",
                    // modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },
                    // collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },

                    meta: cleanProperties(m, { ...context, contextObject: contextObject }),
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, `/api/query-create/${name}`, { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
                ]
            }
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "User"), {
            mode: "dialog",
            relation: {
                uiFilter: () => [
                    {
                        name: "lastname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "firstname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "patronymic",
                        sort: true,
                        filter: true,
                    },

                    {
                        name: "email",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Телефон",
                        name: "phone",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "gender",
                        sort: true,
                        filter: true,
                        display: (o) => o.name,
                    },
                    {
                        label: "Дата создания",
                        name: "createdAt",
                        type: "date",
                        sort: true,
                        filter: true,
                    },
                ],
                displayString: (item) => {
                    return item?.lastname + " " + item?.firstname
                },
                display: (item) => {
                    return (
                        <User item={item} />
                    )
                },
                reference: { object: "User", property: "ID" },
                type: "many-one",
            },
            dropdownActions: undefined,
            queryFilter: [
                QueryDetail("combobox"),
                QueryOrder("firstname", "ASC")
            ]
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Meropriyatie"), {
            mode: "dialog",
            queryFilter: [
                QueryDetail("collection"),
                // QueryOrder("nachaloSorevnovaniya", "ASC"),
                // QueryOrder("nazvanieMeropriyatiya", "ASC")
            ],
            dropdownActions: undefined,
            relation: {
                uiFilter: () => [
                    {
                        name: "nazvanieMeropriyatiya",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "mestoProvedeniya",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "nachaloSorevnovaniya",
                        type: "date",
                        queryRaw: (filterByKey, item, akey) => {
                            return QueryParam("w-lge-" + akey, filterByKey.format("YYYY-MM-DD"))
                        },
                        sort: true,
                        filter: true,
                        sorted: "ASC",
                        filtered: dayjs(dayjs().year() + "-01-01"),
                    },
                ],
                displayString: (item) => {
                    return dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " +
                        item?.nazvanieMeropriyatiya + ", " +
                        _.get(item, "mestoProvedeniya.name")
                },
                display: (item) => {
                    return (
                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                            <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                <YImage item={item} width={32} hidePreview={true} />
                            </div>

                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                    <span style={{ fontWeight: "600" }}>
                                        <a href={`/fed/event/${item.ID}`}>{item.nazvanieMeropriyatiya}</a>
                                    </span>
                                </div>
                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                    <span style={{
                                        marginRight: "5px",
                                        borderRadius: "5px",
                                        backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                        color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                        fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
                                        fontSize: "12px",
                                        boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                        padding: "2px 4px"
                                    }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                    <span>{item?.mestoProvedeniya?.name}</span>
                                </div>
                            </div>
                        </div>
                    )
                },
                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                type: "many-one",
            },
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "TantsevalnayaDistsiplina"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("Nazvanie", "ASC"),
            ],
            dropdownActions: undefined
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Kategoriya"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("Nazvanie", "ASC"),
            ],
            dropdownActions: undefined
        })

        p = foreachInProperties(p, n => (n.type == "string" && !n?.db?.size), {
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                />)
            }
        })

        // p = foreachInProperties(p, n => (obj.name === "NastroikiOtsenokProtokolovTesta" && n.name === "ParametrKriteriya"), {
        //     source: `/api/testisudeiskikhattestatsii/criterion-params-by-tantsor/${contextObject?.ID}`,
        //     dropdownActions: undefined
        // })

        return SetMetaProperties(obj, p)
    }

    const [clipboard, setClipboard] = useClipboardContext()
    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <Tabs defaultActiveKey="system-rating-common">
                    <TabPane key="system-rating-common" tab="Общие">
                        {/* <Action
                            auth={auth}
                            action={(values, unlock, close) => {
                                let href = "/api/sudifederatsii/recalc-isnotcalc-effektivnost-sudei"
                                if (values?.recalcAll) {
                                    href = "/api/sudifederatsii/recalc-all-effektivnost-sudei"
                                }

                                GET(auth, href, ({ data }) => {
                                    close()
                                }, (err) => errorCatch(err, () => unlock()))

                            }}
                            modal={{
                                title: "Расчет эффективности судей"
                            }}
                            okText="Рассчитать"
                            mode={"func"}

                            form={RecalcEffectivnostForm}
                            trigger={(click) => (
                                <div>
                                    <Button type="link" onClick={click}>Расчет эффективности судей</Button>
                                </div>
                            )}
                        /> */}
                    </TabPane>
                    <TabPane tab="Категории турниров" key="kt1">
                        <AbstractCollection
                            auth={auth}
                            name={"KategoriyaTurnira"}
                            columns={() => [
                                {
                                    title: "Название",
                                    render: (text, record) => {
                                        return (record.nazvanie);
                                    }
                                },
                                {
                                    title: "Максимальный балл в зачет",
                                    render: (text, record) => {
                                        return (record.maksBallVZachet);
                                    }
                                }
                            ]}
                            form={Model}
                            meta={() => meta["KategoriyaTurnira"]?.properties.filter(n => {
                                return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
                            })}
                        />
                    </TabPane>
                    <TabPane key="system-rating-tipi-reitingov" tab={"Типы рейтингов"}>
                        <CollectionServer
                            auth={auth}
                            name={"TipiReitingov"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("TipiReitingov")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TipiReitingov", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}


                            linksModelActions={"inline"}
                            scheme={[
                                "ReitingStatusSorevnovaniyaTipReitinga",
                                "RaschetOchkovMezhduKategoriyamiTipReitinga",
                                "RaschetOchkovVnutriKategoriiTipReitinga",
                            ]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions, update, lock, unlock: collectionUnlock }) => {
                                if (name === "ReitingStatusSorevnovaniya") {
                                    let a = []

                                    let eventUrlByAdmin = ""
                                    if (item?.meropriyatie?.organizatorFederatsiyaID) {
                                        eventUrlByAdmin = `/app/federation-administrator/events/${item?.meropriyatie.ID}`
                                    } else if (item?.meropriyatie?.organizatorRegionalnoeOtdelenieID) {
                                        eventUrlByAdmin = `/app/local/${item?.meropriyatie.organizatorRegionalnoeOtdelenieID}/events/${item?.meropriyatie.ID}`
                                    } else if (item?.meropriyatie.organizatorMeropriyatiyaID) {
                                        eventUrlByAdmin = `/app/organizer/${item?.meropriyatie.organizatorMeropriyatiyaID}/events/${item?.meropriyatie.ID}`
                                    } else if (item?.meropriyatie.organizatorShkolaID) {
                                        eventUrlByAdmin = `/app/school/${item?.meropriyatie.organizatorShkolaID}/events/${item?.meropriyatie.ID}`
                                    }

                                    a.push({
                                        auth: auth,
                                        title: (<a href={eventUrlByAdmin} target='_blank'>Изменить мероприятие</a>),
                                        // action: (values, unlock, close) => {}
                                    })
                                    a.push({
                                        auth: auth,
                                        title: "Результаты",
                                        readonly: true,
                                        noAntForm: true,
                                        titles: {
                                            subheader: <div style={{ paddingBottom: "15px" }}><div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {item?.meropriyatie?.nazvanieMeropriyatiya} - {dayjs(item?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item?.meropriyatie, "mestoProvedeniya.name")}
                                            </div></div>
                                        },
                                        modal: {
                                            width: "940px",
                                        },
                                        object: item?.meropriyatie,
                                        form: RezultatiPoMeropriyatiu,
                                        action: (values, unlock, close, { collection, setCollection }) => { }
                                    })
                                    a.push({
                                        type: "divider"
                                    })
                                    a.push({
                                        auth: auth,
                                        title: (<div>
                                            <div>Рассчитать абсолютный рейтинг</div>
                                            <div style={{ fontSize: "12px" }}>
                                                {(!!item?.isCalc) && <span><i className="fa fa-circle" style={{ color: "#27b327" }}></i> Рассчитан {(item?.dateCalc) && <span>({dayjs(item?.dateCalc).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')})</span>}</span>}
                                                {(!item?.isCalc) && <span><i className="fa fa-circle" style={{ color: "red" }}></i>  Не рассчитан {(item?.dateCalc) && <span></span>}</span>}
                                            </div>
                                        </div>),
                                        action: (values, unlock, close) => {
                                            lock()
                                            GET(auth, `/api/rating-period/raschet-reitingovih-ochkov-polzovateley/${item?.meropriyatieID}`, ({ msgList, haveBeenChanges, status }) => {
                                                if (!haveBeenChanges) {
                                                    message.warning('Ничего не изменилось');
                                                } else {
                                                    update()
                                                    message.success('Готово');
                                                }
                                                collectionUnlock()
                                            }, (err) => errorCatch(err, () => { collectionUnlock(); }))
                                        }
                                    })
                                    a.push(...actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) })))
                                    return a
                                }
                                if (name === "TipiReitingov") {
                                    return actions.filter((e) => (e.key != "delete")).map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                }
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                // return actions
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (name === "RaschetOchkovVnutriKategorii" && fieldName === "RaschetOchkovVnutriKategoriiTipReitinga") {
                                    let a = actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                    a.push(({ collection,
                                        setCollection,
                                        setCollectionItem,
                                        removeCollectionItem,
                                        onSelection,
                                        isSelected,
                                        lock,
                                        unlock,
                                        loading: collectionLoading,
                                        update }, idx) => {
                                        return (<Upload key={idx} {...{
                                            name: 'file',
                                            multiple: false,
                                            showUploadList: false,
                                            accept: ".xlsx",
                                            beforeUpload: (f) => {
                                                // setLoading(true);

                                                const formData = new FormData();
                                                formData.append('file', f);

                                                POSTFormData(auth, `/api/raschet-ochkov-vnutri-kategorii/upload-excel/${contextObject?.ID}`, formData,
                                                    (res) => {
                                                        update();
                                                        // setLoading(false);
                                                    },
                                                    (err) => errorCatch);

                                                return false;
                                            },
                                        }}>
                                            <Button loading={collectionLoading} icon={<UploadOutlined />}>Загрузить из Excel</Button>
                                        </Upload>)
                                    })
                                    return a
                                }
                                if (name === "TipiReitingov") {
                                    return actions.filter((e) => (e.key != "create")).map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                }
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                // return actions
                            }}
                        />
                    </TabPane>
                </Tabs>
            </div>
        </PageLayout >
    );
}